<template>
  <div class="build-website-container">
    <div class="page-container-title">分站信息 <div class="btn" @click="handleWebsiteUpgrade">升级分站</div></div>
    <div class="page-content">
      <template v-if="websiteData.url && websiteData.url.length > 0">
        <div v-for="(item, index) in websiteData.url" :key="index" class="item">
          <div class="name">前端地址</div>
          <div class="value">{{ item.Url }}</div>
          <div class="btn" @click="handleCopy(item.Url)">复制</div>
        </div>
        <div class="item">
          <div class="name">后台地址</div>
          <div class="value">{{ websiteData.url[0].Url }}/admin.html</div>
          <div class="btn" @click="handleCopy(websiteData.url[0].Url + '/admin.html')">复制</div>
        </div>
      </template>
      <div class="item">
        <div class="name">管理员账号</div>
        <div class="value">{{ websiteData.admin_user }}</div>
      </div>
      <div class="item">
        <div class="name">管理员密码</div>
        <div class="value">******</div>
        <div class="btn" @click="handleWebsiteResetPwd">重置</div>
      </div>
      <div class="item">
        <div class="name">网站名称</div>
        <div class="value">{{ websiteData.site_name }}</div>
      </div>
    </div>
    <websiteUpgradeComponent v-if="dialog.upgrade" ref="websiteUpgradeDialog" @success="onSuccess" @close="dialog.upgrade = false" />
    <websiteResetPwdComponent v-if="dialog.pwd" ref="websiteResetPwdDialog" @success="onSuccess" @close="dialog.pwd = false" />
  </div>
</template>

<script>
import websiteUpgradeComponent from './WebsiteUpgradeComponent'
import websiteResetPwdComponent from './WebsiteResetPwdComponent'
import { mapState, mapActions } from 'vuex'
export default {
  name: "WebsiteInfoComponent",
  components: {
    websiteUpgradeComponent,
    websiteResetPwdComponent,
  },
  data() {
    return {
      websiteData: {},
      dialog: {
        upgrade: false,
        pwd: false
      }
    }
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  watch: {
    
  },
  mounted() {
    this.handleGetWebsiteInfo()
  },
  methods: {
    ...mapActions(['GetUserInfo']),
    onSuccess() {
      this.GetUserInfo()
    },
    handleCopy(text) {
      this.$copyText(`${text}`).then(() => {
        this.$toast('复制成功')
      }).catch(() => {
        this.$toast('复制失败')
      })
    },
    handleWebsiteUpgrade() {
      this.dialog.upgrade = true
      this.$nextTick(() => {
        this.$refs.websiteUpgradeDialog.open()
      })
    },
    handleWebsiteResetPwd() {
      this.dialog.pwd = true
      this.$nextTick(() => {
        this.$refs.websiteResetPwdDialog.open()
      })
    },
    async handleGetWebsiteInfo() {
      var res = await this.$API.substationsInfo.post()
      this.websiteData = res.info
    }
  },
}
</script>

<style lang="less" scoped>
.page-container-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0 14px;
  height: 25px;
  padding-left: 20px;
  position: relative;
  color: #5783fc;
  line-height: 25px;
  font-size: 18px;
  border-bottom: 1px solid #e5e5e5;
  &::after {
    content: '';
    position: absolute;
    width: 5px;
    height: 25px;
    border-radius: 3px;
    background-color: #5783fc;
    left: 0;
    top: 20px;
  }
  .btn {
    padding: 0 10px;
    cursor: pointer;
    background-color: #1399ff;
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
    line-height: 24px;
  }
}
.build-website-container {
  padding: 0 15px;
}
.page-content {
  margin: 20px 12px 0;
  overflow: hidden;
  position: relative;
  border-radius: 8px;
  background-color: #fff;
  .item {
    margin: 0 12px;
    height: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f8f8f8;
    font-size: 14px;
    color: #242941;
    .name {
      width: 84px;
    }
    .value {
      flex: 1;
    }
    .btn {
      cursor: pointer;
      margin-left: 12px;
      color: #1399ff;
    }
  }
}
</style>